import React from "react";
import Styled from "@emotion/styled";

const Reflection = (props) => {
  const Container = Styled.div`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        min-width: 900px;

        @media (max-width: 1100px) {
          min-width: 0;
          flex-direction: column;
        }
    `;
  const Subheader = Styled.div`
        font-size: 3em;
        color: #35a1f9;
        margin-bottom: 2vh;

        @media (max-width: 1100px) {
          font-size: 1.5em;
        }
    `;
  const Title = Styled.div`
    color: #000000;
    font-size: 5em;
    font-weight: 600;

    @media (max-width: 1100px) {
      font-size: 2em;
    }
  `;

  const Text = Styled.div`
    font-size: 1.0vw;
    width: 65vw;
    line-height: 1.7em;

    @media (max-width: 1100px) {
      width: 100%;
      min-width: 0;
      font-size: 1em;
    }
  `;

  const DownloadLinkContainer = Styled.div`
  margin-top: 7vh;
  font-size: 3em;
  color: #191919;
  margin-bottom: 2vh;
  cursor: pointer;
  text-decoration: underline;
  -moz-user-select: none; 
  -webkit-user-select: none; 
  -ms-user-select:none; 
  user-select:none;
  -o-user-select:none;
  display: flex;
  flex-direction: row;

  @media (max-width: 1100px) {
    min-width: 0;
    flex-direction: column;
    font-size: 2em;
  }
  `;

  const DownloadLink = Styled.a`
    color: #191919;
    margin-right: 5vw;

    @media (max-width: 1100px) {
      width: 100%;
      min-width: 0;
      font-size: 0.5em;
      margin-top: 5%;
    }
  `;

  var style = {};
  return (
    <div
    // className={
    //   props.isVisible ? "animated fadeInDown" : "animated fadeOutDown"
    // }
    >
      <Title>Conclusion</Title>
      <Subheader>Reflection</Subheader>
      <Container>
        <Text>
          It should be noted the driver in the 500 iterations technically did
          not do everything correctly. It can be seen to make a left turn into
          the right lane as opposed to turning into the closet lane; which is
          the left lane. This is improper driving and can sometimes result in a
          fine. This is one of the aspects that can be improved upon by adding
          in more data to train, or changing the desired outcomes that the AI
          learns from. <br></br>
          <br></br>This project had a good combination of math, physics, Java,
          artificial intelligence, and software development. It allowed me to
          practice proper programming methodologies and required me to take
          initiatives as adhering to my self-imposed deadlines were crucial in
          ensuring the project would be completed in time.<br></br>
          <br></br>Now that I have more experience with game and software
          development and artificial intelligence, I look forward to undertaking
          even more sophisticated projects in the near future.
        </Text>
      </Container>
      <DownloadLinkContainer>
        <DownloadLink
          href={
            "https://drive.google.com/file/d/13yDz38VB_d7tczjvrrJ-KF0dX3xwF-0v/view?usp=sharing"
          }
          target="_blank"
        >
          Download the jar
        </DownloadLink>
        {/* </DownloadLinkContainer>
      <DownloadLinkContainer style={{}}> */}
        <DownloadLink
          href={"https://github.com/kylewuu/driver"}
          target={"_blank"}
        >
          Checkout the repo on Github
        </DownloadLink>
      </DownloadLinkContainer>
    </div>
  );
};
export default Reflection;
